import css from './index.module.scss';
import { LineSpace } from '@/components/ProductComponents';
import { ImgCellsWithText, SwiperBanner, TextModule, TextOnImage, TextWithImage } from '@/components/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import OtherList from '@/components/ProductCommon/OtherList';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_river_river_768', 'product_ps_delta_delta_2'],
};

export default function Content() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('product');
    const languageT = (value: string) => t(`solarpanels.${value}`);
    const webpUrl = '/media/solarpanel_160w/pc/';

    const bannerData3 = [
        {
            img: ['banner1.webp', 'banner1.jpg'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item1_desc'),
        },
        {
            img: ['banner2.webp', 'banner2.jpg'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item2_desc'),
        },
        {
            img: ['banner3.webp', 'banner3.jpg'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item3_desc'),
        },
    ];
    const item1 = {
        synopsis: languageT('item1_synopsis'),
        desc: languageT('item1_desc'),
        bgImgs: ['3_screen.webp', '3_screen.jpg'],
    };

    const textData1 = {
        img_url: ['4_camera_160w.webp', '4_camera_160w.jpg'],
        title: languageT('textData1_tit'),
        synopsis: languageT('textData1_synopsis'),
        desc: languageT('textData1_desc'),
    };

    const textData2 = {
        img_url: ['7_solar.webp', '7_solar.jpg'],
        title: languageT('textData2_tit'),
        synopsis: languageT('textData2_synopsis'),
        desc: languageT('textData2_desc'),
    };

    const imgCellData = {
        guide: languageT('imgCellData_guide'),
        title: languageT('imgCellData_tit'),
        desc1: languageT('imgCellData_desc1'),
        desc2: languageT('imgCellData_desc2'),
        supliment: languageT('imgCellData_sup'),
        items: [
            {
                url: '/img/productDetails/solarpanel/5_solar-panel1.png',
                guide: languageT('imgcell_item1_guid'),
                titleLeft: languageT('imgcell_item1_titl'),
                titleRight: languageT('imgcell_item1_titr'),
                desc: languageT('imgcell_item1_desc'),
            },
            {
                url: '/img/productDetails/solarpanel/5_solar-panel2.png',
                guide: languageT('imgcell_item2_guid'),
                titleLeft: languageT('imgcell_item2_titl'),
                titleRight: languageT('imgcell_item2_titr'),
                desc: languageT('imgcell_item2_desc'),
            },
            {
                url: '/img/productDetails/solarpanel/5_solar-panel3.png',
                guide: languageT('imgcell_item3_guid'),
                titleLeft: languageT('imgcell_item3_titl'),
                titleRight: languageT('imgcell_item3_titr'),
                desc: languageT('imgcell_item3_desc'),
            },
            {
                url: '/img/productDetails/solarpanel/5_solar-panel4.png',
                guide: languageT('imgcell_item4_guid'),
                titleLeft: languageT('imgcell_item4_titl'),
                titleRight: languageT('imgcell_item4_titr'),
                desc: languageT('imgcell_item4_desc'),
            },
        ],
    };

    const descFontSize: any = {
        us: 22,
        jp: 20,
        de: 21,
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <LineSpace height={150} background="transparent" />

            <div className="banner-content">
                <div className="section section1">
                    <div className="section sec1-top">
                        <h3 className="tit">{languageT('ytdd_sec1-top_tit')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_160w/pc/sec1-top.webp')}
                                src={require('@publicLocal/product/solarpanel_160w/pc/sec1-top.png')}
                                className="fullImgs"
                                alt={languageT('solar_panels')}
                            />
                        </div>
                    </div>
                    <div className="section sec1-btm">
                        <h3 className="tit">{languageT('ytdd_sec1-btm_tit')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_160w/pc/sec1-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_160w/pc/sec1-btm.png')}
                                className="fullImgs"
                                alt={languageT('solar_panels')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-top">
                        <div className="section sec2-top-l">
                            <h3 className="tit">{languageT('ytdd_sec2-top-l_tit')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_160w/pc/sec2-top-l.webp')}
                                    src={require('@publicLocal/product/solarpanel_160w/pc/sec2-top-l.png')}
                                    className="fullImgs"
                                    alt={languageT('solar_panels')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3 className="tit">{languageT('ytdd_sec2-top-r_tit')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_160w/pc/sec2-top-r.webp')}
                                    src={require('@publicLocal/product/solarpanel_160w/pc/sec2-top-r.jpg')}
                                    className="fullImgs"
                                    alt={languageT('solar_panels')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">{languageT('ytdd_sec2-btm_tit')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_160w/pc/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_160w/pc/sec2-btm.png')}
                                className="fullImgs"
                                alt={languageT('solar_panels')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <LineSpace height={150} background="transparent" />
            <TextOnImage data={item1} config={{ position: 'top', cls: 'textImg1', descFontSize: descFontSize[locale] || descFontSize.us, webpUrl }} />
            <LineSpace height={120} background="transparent" />
            <TextWithImage
                data={textData1}
                config={{
                    position: 'top',
                    descFontSize: descFontSize[locale] || descFontSize.us,
                    webpUrl,
                    width: (() => {
                        const map = {
                            it: '980px',
                        };
                        return map[locale as keyof typeof map] || '924px';
                    })(),
                }}
            />
            <LineSpace height={150} background="transparent" />
            <ImgCellsWithText data={imgCellData} descFamily={'Manrope-SemiBold'} />
            <LineSpace height={180} background="transparent" />
            <TextModule
                data={{ text: languageT('mc_connectors') }}
                cssStyle={{
                    fontClass: 'font-family-semibold',
                    fontSize: locale === 'jp' ? '26px' : '32px',
                    lineHeight: '40px',
                    margin: '30px auto 0 auto',
                    textAlign: 'center',
                    width: '924px',
                    fontWeight: locale === 'cn' ? 400 : 500,
                }}
            />
            <TextModule
                data={{ text: languageT('perfect_couple') }}
                cssStyle={{
                    type: 'ls',
                    fontClass: 'font-family-extrabold',
                    margin: '10px auto 0 auto',
                    textAlign: 'center',
                    width: '924px',
                    fontSize: locale === 'jp' ? '60px' : '64px',
                    fontWeight: locale === 'cn' ? 500 : 700,
                }}
            />
            <TextModule
                data={{
                    text: languageT('perfect_couple_desc'),
                }}
                cssStyle={{
                    type: 'sm',
                    fontFamily: 'var(--font-family-SemiBold)',
                    fontWeight: locale === 'cn' ? 500 : 600,
                    fontSize: ['jp', 'tw'].includes(locale) ? '20px' : '22px',
                    margin: '40px auto 90px auto',
                    textAlign: 'center',
                    width: '924px',
                }}
            />
            <div className="banner-content" style={{ height: '800px' }}>
                <NextImage
                    webpSrc={require('@publicLocal/product/solarpanel_160w/pc/6_drone.webp')}
                    src={require('@publicLocal/product/solarpanel_160w/pc/6_drone.jpg')}
                    className="fullImgs"
                    alt={languageT('mc_connectors')}
                />
            </div>
            <LineSpace height={150} background="transparent" />
            <SwiperBanner
                data={{
                    guide: { text: languageT('swiper_guide') },
                    title: { text: languageT('swiper_tit') },
                    desc: { text: '' },
                    items: locale == 'sa' ? [...bannerData3.reverse()] : bannerData3,
                }}
                cssStyle={{
                    fontFamily: 'var(--font-family-SemiBold)',
                    fontWeight: '600',
                    type: 'container_image_with_text_top',
                    titleStyle: { margin: '10px 0 90px 0' },
                    webpUrl,
                }}
            />
            <LineSpace height={220} background="transparent" />
            <TextWithImage
                data={textData2}
                config={{
                    position: 'top',
                    descFontSize: descFontSize[locale] || descFontSize.us,
                    width: ['cn', 'tw'].includes(locale) ? '960px' : null,
                    webpUrl,
                }}
            />
            <LineSpace height={150} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
